/**
 * @file pendingWindow.js
 * @description Opens a new tab synchronously within a user gesture so it can be
 * pointed at a URL resolved asynchronously without being blocked as a pop-up.
 */

export function openPendingWindow() {
    const pendingWindow = window.open('', '_blank');

    if (pendingWindow) {
        pendingWindow.opener = null;
    }

    return pendingWindow;
}

export function navigatePendingWindow(pendingWindow, url) {
    if (pendingWindow && !pendingWindow.closed) {
        pendingWindow.location.replace(url);
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
}

export function closePendingWindow(pendingWindow) {
    if (pendingWindow && !pendingWindow.closed) {
        pendingWindow.close();
    }
}
